import React, { useState } from "react";
import DisplacementMap from "./DisplacementMap";
import DisplacementSlider from "./DisplacementSlider";
import "./Displacement.css";

const demographicGroups = [
  "asian",
  "black",
  "hispanic",
  "native-american",
  "white",
  "other",
] as const;
type DemographicGroup = (typeof demographicGroups)[number];

const Displacement: React.FC = () => {
  const [selectedGroup, setSelectedGroup] = useState<DemographicGroup>(
    demographicGroups[0]
  );
  const [selectedGroupIndex, setSelectedGroupIndex] = useState<number>(0);

  const handleSliderChange = (index: number) => {
    setSelectedGroup(demographicGroups[index]);
    setSelectedGroupIndex(index);
  };

  return (
    <>
      <div className="maps-container">
        <div className="map-container">
          <h2 className="map-title">Percent of Population (2010 Census)</h2>
          <DisplacementMap year="pop_2010" demographic={selectedGroup} />
        </div>
        <div className="map-container">
          <h2 className="map-title">Percent of Population (2020 Census)</h2>
          <DisplacementMap year="pop_2020" demographic={selectedGroup} />
        </div>
      </div>
      <DisplacementSlider
        options={demographicGroups as unknown as string[]}
        value={selectedGroupIndex}
        onChange={handleSliderChange}
      />
    </>
  );
};

export default Displacement;
